import { IFilterAuditsCriteria } from "src/app/audits/interfaces/filter-audits-criteria.interface";
import { IAudit } from "../../interfaces/IAudit";
import { IConfirmAuditDetails } from "../../interfaces/IConfirmAuditDetails";
import { ICreateAuditPayload } from "../../interfaces/ICreateAuditPayload";

export class GetAudits {
    static readonly type = '[Audits] Get audits';
  
    constructor(public criteria: IFilterAuditsCriteria) {
    }
}

export class CreateAudit {
    static readonly type = '[Audits] create a new audit';
  
    constructor(public payload: ICreateAuditPayload) {
    }
}

export class GetAuditWithDetails {
    static readonly type = '[Audits] get audit details';
  
    constructor(public id: number ) {
    }
}

export class DeleteAudit {
    static readonly type = '[Audits] delete audit physically';
  
    constructor(public id: number ) {
    }
}
export class AddNewNdc {
    static readonly type = '[Audits] add new ndc';
  
    constructor(public payload: any ) {
    }
}

export class RemoveNdc {
    static readonly type = '[Audits] remove ndc';
  
    constructor(public id: string ) {
    }
}


export class ConfirmAuditDetail {
    static readonly type = '[Audits] confirm audit detail';
  
    constructor(public payload: IConfirmAuditDetails ) {
    }
}

export class CompleteAudit {
    static readonly type = '[Audits] complete audit';
  
    constructor(public payload: any) {
    }
}


export class SetAuditsList {
    static readonly type = '[Audits] set audits list';
  
    constructor(public audits: IAudit[]) {
    }
}

export class ValidateDetails {
    static readonly type = '[Audits] validate ndcs';
  
    constructor(public payload: any) {
    }
}

export class RemovePendingTransactionFromAuditDetail {
    static readonly type = '[Audits] remove pending transaction from audit detail';
  
    constructor(public drugId: number, public pendingTransactionId: number) {
    }
    
}

export class IsUnconfirmedBackCountNdcExists {
    static readonly type = '[Audits] Is Unconfirmed Back Count Ndc Exists';
  
    constructor(public locationID: string, public drugID: string) {
    }
}

export class BulkGetNdcsExistInUnconfirmedBackCount {
    static readonly type = '[Audits] Bulk Get Ndcs Exist In Unconfirmed Back Count';
    constructor(public drugsAndLocations: { locationID: string, drugID: string }[]) {}
}



export class SaveAuditsFilters {
    static readonly type = '[Audits] Save Audits Filters';
  
    constructor(public filtersForm: string) {
    }
}


export class GetBackCountsInProgressCount {
    static readonly type = '[Audits] Get BackCounts In Progress Count';
  
    constructor() {
    }
}

export class GetFirstBackCountID {
    static readonly type = '[Audits] Get First BackCount ID';
  
    constructor() {
    }
}

export class DecrementBackCountsTotal {
    static readonly type = '[Audits] Decrement Back Counts Total';
    
    constructor() {
    }
}

